module.exports = __webpack_public_path__ + "img/Stemness-CECA_10X_CC.ff91d575.png";